import ChallengeApp from 'apps/ChallengeApp'
import { getCommonStaticProps } from 'commonPage'
import commonMessages from 'lang/es/common'

export default ChallengeApp

export const getStaticProps = async () => {
  const commonStaticProps = await getCommonStaticProps()

  const messages = {
    ...commonMessages,
  }

  return {
    props: {
      titleMeta: 'META_TITLE_QRO',
      descriptionMeta: 'META_DESCRIPTION_QRO',
      messages,
      headerProps: {
        isDisabledSticky: true,
      },
      ...commonStaticProps,
    },
  }
}
